// extracted by mini-css-extract-plugin
export default {"sectionTitle":"DeviceManagementSection_sectionTitle","deviceCounter":"DeviceManagementSection_deviceCounter"};